import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import axios from "src/config/axios";
import OnlineReservationPriceTable from "src/pages/OnlineReservations/OnlineReservationPriceTable";

const ReservationPricePreview = ({ attributes, bookingId }) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const pricing = JSON.stringify({
    from: attributes.from,
    to: attributes.to,
    parking_slot_id: attributes.parking_slot_id,
    amount_guests: attributes.amount_guests,
    amount_dogs: attributes.amount_dogs,
    reservation_child_ages: attributes.reservation_child_ages,
  });

  useEffect(() => {
    let current = true;
    setLoading(true);
    setQuote(null);
    setError(null);
    const timer = setTimeout(async () => {
      try {
        const { data } = await axios.post(
          "/api/v1/online_reservations/quote.json",
          {
            online_reservation: JSON.parse(pricing),
            booking_id: bookingId,
          }
        );
        if (current) setQuote(data);
      } catch (requestError) {
        if (current && requestError.response?.status !== 422)
          setError("Die Preisvorschau konnte nicht geladen werden.");
      } finally {
        if (current) setLoading(false);
      }
    }, 350);
    return () => {
      current = false;
      clearTimeout(timer);
    };
  }, [pricing, bookingId]);

  return (
    <div className="mb-3" aria-live="polite">
      {loading && (
        <p>
          <Spinner animation="border" size="sm" className="mr-2" />
          Preis wird berechnet…
        </p>
      )}
      {error && <Alert variant="info">{error}</Alert>}
      {quote && <OnlineReservationPriceTable onlineReservation={quote} />}
    </div>
  );
};

export default ReservationPricePreview;
